import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    url: String,
    param: { type: String, default: 'value' },
    frame: String,
    includeFields: { type: Array, default: [] },
  };

  reload(event) {
    if (!this.hasFrameValue || !this.hasUrlValue) return;

    const url = new URL(this.urlValue, window.location.origin);

    if (this.includeFieldsValue.length > 0) {
      this.serializeFields(event.target, url);
    }

    const value = event.target.value;
    if (value) {
      url.searchParams.set(this.paramValue, value);
    } else {
      url.searchParams.delete(this.paramValue);
    }

    const frame = document.getElementById(this.frameValue);
    if (frame) {
      frame.src = url.toString();
    }
  }

  serializeFields(target, url) {
    const form = target.closest('form');
    if (!form) return;

    const allowed = new Set(this.includeFieldsValue);
    const formData = new FormData(form);
    for (const [key, value] of formData.entries()) {
      if (!allowed.has(key)) continue;
      if (value instanceof File) continue;
      url.searchParams.append(key, value);
    }
  }
}
